import { render, staticRenderFns } from "./CustomizationsModal.vue?vue&type=template&id=2fafee91&"
import script from "./CustomizationsModal.vue?vue&type=script&lang=js&"
export * from "./CustomizationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports